import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as actions from "../../../../_redux/school-reports/SchoolReportsAction";
import { noRecordsAlert, resultAlert } from "../../../../../../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../../_metronic/_partials/controls";
import { useSchoolReportStudentsUIContext } from "./SchoolReportStudentsUIContext";
import { SchoolReportStudentsFilter } from "./school-report-students-filter/SchoolReportStudentsFilter";
import { SchoolReportStudentsTable } from "./school-report-students-table/SchoolReportStudentsTable";

export function SchoolReportStudentsCard({
  reportId,
  goNext
}) {
  // School Report Students UI Context
  const schoolReportStudentsUIContext = useSchoolReportStudentsUIContext();
  const schoolReportStudentsUIProps = useMemo(() => {
    return {
      ids: schoolReportStudentsUIContext.ids
    };
  }, [schoolReportStudentsUIContext]);
    
  // Getting curret state of School Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { actionsLoading } = currentState;

  // School Reports Redux state
  const dispatch = useDispatch();

  /** Belli Bir Okul Karnesinin Hazırlanacağı Öğrenci Listesini Kaydeder */
  const saveReceipents = (ids) => {
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }      
    dispatch(actions.saveReceipents(reportId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => goNext(), 2500);
  };

  const title = <>Karne Öğrencileri{schoolReportStudentsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{schoolReportStudentsUIProps.ids.length}</span>]</> : ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => saveReceipents(schoolReportStudentsUIProps.ids)}
          >
            Kaydet ve İlerle
            <span className="svg-icon svg-icon-md ml-1">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
            </span>
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <SchoolReportStudentsFilter />
        <SchoolReportStudentsTable />
      </CardBody>
    </Card>
  );
}